import {
  CC_ONBOARDING_MAX_STEPS_UNAUTH,
  CC_ONBOARDING_STEP_ADDRESS,
  CC_ONBOARDING_STEP_PHONE,
  CC_ONBOARDING_STEP_SSN,
} from 'components/features/creditCard/creditCardStore/constants'
import { onboardingStepsCountSelector } from 'components/features/creditCard/creditCardStore/selectors'
import { useStoreSelector } from 'helpers/reactReduxHelpers'
import { useMemo } from 'react'


type Steps =
  | typeof CC_ONBOARDING_STEP_ADDRESS
  | typeof CC_ONBOARDING_STEP_PHONE
  | typeof CC_ONBOARDING_STEP_SSN

const steps: Steps[] = [
  CC_ONBOARDING_STEP_ADDRESS,
  CC_ONBOARDING_STEP_PHONE,
  CC_ONBOARDING_STEP_SSN,
]

export const useStepNumber = (step: Steps) => {

  const stepsCount = useStoreSelector(onboardingStepsCountSelector)
  return useMemo(() => {

    let index = steps.indexOf(step) + 1

    if (stepsCount === CC_ONBOARDING_MAX_STEPS_UNAUTH) {
      index += 2
    }
    return index
  }, [step, stepsCount])
}
